'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/environment-is-webos-webkit.js
// module id = 662
// module chunks = 13